import useGoogleMapApiKey from "features/shared/useGoogleMapApiKey";
import { Skeleton } from "@chakra-ui/skeleton";
import { Empty } from "antd";
import BaseMap from "./BaseMap";

interface GoogleMapProps {
  latitude?: number;
  longitude?: number;
  onCoordinatesChange?: (latitude: number, longitude: number) => void;
}

function GoogleMap({
  latitude,
  longitude,
  onCoordinatesChange,
}: GoogleMapProps) {
  const { data, isLoading } = useGoogleMapApiKey();

  if (
    isLoading ||
    (!Number.isFinite(latitude) && !Number.isFinite(longitude))
  ) {
    return <Skeleton w="100%" h="400px" />;
  }

  if (!isLoading && !data) {
    return <Empty description="Erro ao carregar o mapa" />;
  }

  return (
    <BaseMap
      apiKey={data!}
      latitude={latitude!}
      longitude={longitude!}
      onCoordinatesChange={onCoordinatesChange}
    />
  );
}

export default GoogleMap;
